import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { useForm } from 'react-hook-form'

import { Button } from '../../../../../../../../components/Button'

type SkillsFormProps = {
  defaultValues?: SkillsFieldsValues
  onSubmit: (data: SkillsFieldsValues) => void
  isSubmitting: boolean
}

const schema = yup.object().shape({
  bio: yup.string().nullable().notRequired(),
  observations: yup.string().nullable().notRequired(),
})

export type SkillsFieldsValues = {
  bio?: string
  observations?: string
}

export const SkillsForm = ({
  defaultValues,
  isSubmitting,
  onSubmit,
}: SkillsFormProps) => {
  const { register, handleSubmit } = useForm<SkillsFieldsValues>({
    resolver: yupResolver(schema),
    defaultValues,
  })

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="mb-4">
        <label htmlFor="bio" className="block mb-4">
          Bio:
        </label>
        <textarea
          id="bio"
          className="w-full h-[120px] outline-none p-3 text-sm rounded-lg resize-none lg:text-base placeholder:text-grey-700 border-1 border-grey-700"
          {...register('bio')}
        />
      </div>

      <div className="mb-8">
        <label htmlFor="observations" className="block mb-4">
          Observação:
        </label>
        <textarea
          id="observations"
          className="w-full h-[120px] outline-none p-3 text-sm rounded-lg resize-none lg:text-base placeholder:text-grey-700 border-1 border-grey-700"
          {...register('observations')}
        />
      </div>

      <div className="flex gap-2">
        <Button type="submit" isLoading={isSubmitting}>
          Salvar
        </Button>
      </div>
    </form>
  )
}
